export default {
  CARD_LIST: {
    NO_DATA: {
      DEFAULT: 'Det er ikkje noko å vise',
      HEADING: 'Ingen data!',
      INFO: 'Mogleg årsak:',
      CAUSE_1: 'Du har ingen elevar knytt til brukaren din.',
      CAUSE_2: 'Ingen elevar har fullført nokre læringsstiar enno. Treng du hjelp, kontakt oss på:',
    },
  },

  HEADER_BAR: {
    TITLE: 'Språk og innlogging',
    BACK: 'Tilbake',
    OPEN_MODAL_BUTTON: 'Innhald',
    MAIN_LANGUAGE: 'Hovudspråk',
    MAIN_LANGUAGE_SUBTEXT: 'Endrar språk i navigasjon og innhald',
    MOTHER_TONGUE: 'Morsmål',
    MOTHER_TONGUE_SUBTEXT: 'Endrar språk berre for omsett tekst',
    SELECT_MOTHER_TONGUE: 'Vel Morsmål',
    DESELECT: 'Fjern val',
    HOME: 'Heim',
    GO_TO_CONTENT: 'Hopp til hovedinnhold',
  },

  OPEN_MODAL: {
    CAPTION: 'Vis',
  },

  SEARCH_FIELD: {
    PLACEHOLDER: {
      SEARCH: 'Søk i alt',
      FILTER: 'Filtrer',
      FILTER_CONTENT: 'Filtrer innhold',
    },
    FILTER: {
      PLACEHOLDER: 'Søkefilter',
    },
  },

  ARIA: {
    CLOSE_MODAL: 'Lukk',
  },

  FOOTER: {
    PRIVACY: 'Personvern',
    CONTACT: 'Kontakt oss',
  },

  IMAGE_MODAL: {
    HEADER: 'Bilde',
    FIT_SCREEN: 'Tilpassa',
    FULL_WIDTH: 'Full breidde',
  },

  LEVEL_MODAL: {
    CLOSE: 'Lukk',
  },

  FACT_BOX: {
    HIDE: 'Skjul',
    READ_MORE: 'Les meir',
  },

  LANGUAGE: {
    en: 'English',
    nn: 'Nynorsk',
    nb: 'Bokmål',
    ar: 'Arabic',
    // Note: This is subject to change, `Dari` is just available in ISO standard in projects
    'fa-AF': 'Dari',
    ku: 'Kurdish',
    ps: 'Pashto',
    pl: 'Polish',
    so: 'Somali',
    sw: 'Swahili',
    ti: 'Tigrinya',
    tr: 'Turkish',
  },

  SEARCH: {
    DURATION: 'Tid',
    TOTAL: 'Treff',
    EXPAND: 'Vis alle treff',
  },

  VIDEO: {
    READ_TRANSCRIPTION: 'Vis teksten',
    CHAPTERS: 'Kapittel',
    TEXT_IN_VIDEO: 'Transkripsjon',
  },

  CHAPTERS: {
    HIDE: 'Skjul kapittel',
    SHOW: 'Vis kapittel',
  },

  LEVEL_RATING: {
    LABEL: 'Nivå:',
  },

  HOME: {
    LAST_USED: 'Sist brukt',
  },

  AUDIO_PLAYER: {
    LISTEN: 'Lytt til teksten',
    ERROR_NOT_ALLOWED: 'Lyden er klar, Lytt til teksten.',
    SPEED: {
      SLOWLY: 'Langsamt',
      QUICKLY: 'Hurtig',
    },
  },

  LOGOUT: {
    TEXT: 'Logg ut',
  },

  LOGIN: {
    TEXT: 'Logg in',
  },

  FILTERS: {
    LABEL: 'Filtrer',
    LEVELS_LABEL: 'Nivå',
    SKILLS_LABEL: 'Ferdigheiter',
    ALL: 'Alle',
    NO_LEVELS: 'Ingen nivå',
    ARTICLES: 'Tekstar',
    TASKS: 'Oppgåver',
    CLOSE: 'Lukk',
    DOCUMENT: 'Dokument',
    CATEGORY: 'Kategori',
    STUDENTS: 'Elever',
    CLASSES: 'Klasser',
    GROUPS: 'Grupper',
    RESET: 'Nullstill filter',
    SUBJECT_CONTENT: 'Faginnhald',
    CHOOSE_SUBJECT: 'Vel fag',
    CHOOSE_CONTENT: 'Vel innhald',
    CHOOSE_SKILLS: 'Vel ferdigheiter',
    MORE_FILTERS: 'Fleire filter',
  },

  VIDEO_BLOCK: {
    DEFAULT_TITLE: 'Video',
  },

  DURATION_TIME: {
    LABEL: 'Varigheit:',
  },

  CARD: {
    EXTERNAL_LABEL: 'Ekstern lenkje',
    EXTERNAL_BUTTON: 'Opne i ny fane',
    GO_TO: 'Gå til',
    MODAL: 'Les meir',
    DOWNLOAD: 'Last ned',
    OPEN: 'Opne',
    CHAPTER: {
      GO_TO_TOPIC: 'Gå til tema',
      START: 'Start',
      CONTINUE: 'Fortsett',
      RETAKE: 'Ta på nytt',
      TASKS: 'oppgaver',
      NOT_STARTED: 'Ikke startet',
    },
  },

  ARTICLE: {
    CHAPTER: 'Kategori',
    SUBJECT: 'Underkategori',
    AUTHOR: 'Forfattar',
    GOALS: 'Kompetansemål',
    TEST_YOUR_KNOWLEDGE: 'Test dine kunnskaper',
  },

  COMPETENCY_AIMS: {
    HEADER: 'Kompetansemål',
  },

  TIME_LABEL: {
    LABEL: 'Ca. lesetid',
    SHORT_LABEL: 'Tid',
    DAYS: '{ count } dag | { count } dager',
    HOURS: '{ count } time | { count } timer',
    MINUTES: '{ count } minutter | { count } minutter',
    SECONDS: '{ count } sekunder | { count } sekunder',
  },

  SEARCH_MODAL: {
    SEARCH: 'Søk',
  },

  CONTENT_TYPE_SELECT: {
    ALL: 'Alle',
    LEARNING_PATHS: 'Læringsstiar',
    ALL_CONTENT: 'Alt innhald',
  },

  CONTENT_TYPE: {
    FACTBOX: 'Faktaboks',
    IMAGE: 'Bilde',
    ACCORDION: 'trekkspillmeny',
    CHECKBOX: 'Avmerkingboks',
  },

  TYPE: {
    ARTICLE: 'Artikkel',
    CONCEPT: 'Omgrep',
    EXTERNALLINK: 'Ekstern link',
    VIDEO: 'Video',
    TASK: 'Oppgåve',
    DOCUMENT: 'Dokument',
    PROJECT: 'Prosjekt',
    TEST: 'Test',
    MULTIMEDIA: 'Multimedia',
    CATEGORY: 'Kategori',
    LEARNING_PATH: 'Læringssti',
  },

  ERROR: {
    NOT_FOUND_TITLE: 'Noe gikk galt!',
    NOT_FOUND_MESSAGE:
      '<strong>Mulig årsak:</strong><br />' +
      '1. Siden finnes ikke lengre, eller har fått ny url-adresse.<br />' +
      '2. Du må logg inn for å se innholdet  (“Språkvalg og innlogging” øverst til høyre).<br />' +
      '3. Du mangler tilgang til denne siden eller produktet. Kontakt din lærer eller skoleadministrator for hjelp.',
    ACCESS_DENIED_TITLE: 'Du har dessverre ikkje tilgang til denne sida',
    ACCESS_DENIED_MESSAGE: 'Enkelte sider er berre tilgjengeleg for nokre typar brukarar.',
    ACCESS_FORBIDDEN_TITLE: 'Du har dessverre ikkje tilgang til denne sida',
    ACCESS_FORBIDDEN_MESSAGE: 'Enkelte sider er berre tilgjengeleg for nokre typar brukarar.',
    PAYMENT_REQUIRED_TITLE: 'Du har dessverre ikke tilgang på dette produktet',
    PAYMENT_REQUIRED_MESSAGE:
      'Hør med din lærer eller skoleadministrator hva du kan gjøre for å få tilgang, eller besøk denne siden for mer info',
    HOMEPAGE_LINK: 'Gå til forsida',
    DEFAULT_TITLE: 'Noko gjekk gale!',
    DEFAULT_MESSAGE: 'Finn ikkje denne nettsida.',
  },

  CARDS_CONTAINER: {
    RELATED_LINKS: 'Relatert innhold',
  },

  FILTERS_SELECTOR: {
    BUTTON_TEXT: 'Gå til faginnhold',
  },

  DOCUMENT_CARD: {
    LABEL: 'Dokument',
    DOWNLOAD: 'Last ned',
  },

  EXERCISE: {
    CONTROL_TEXT: 'Metadata',
    META: {
      TIME: 'Tid',
      CURRICULUM_OBJECTIVES: 'Lærerplanmål',
      ASSESSMENT_PROPOSAL: 'Forslag til vurdering',
      GO_TO_ARTICLE: 'Gå til artikkel',
    },
  },

  ARTICLE_NAVIGATION: {
    LABEL: 'Innhold',
  },

  CONCEPT: {
    LABEL: 'Omgrep',
  },

  QUESTION_VALIDATION: {
    CORRECT: 'Riktig',
    INCORRECT: 'Feil',
  },

  QUESTION_GROUP: {
    SEE_RESULTS: 'Se ressultat',
  },

  QUESTION_GROUP_FEEDBACK: {
    CORRECT: 'Veldig bra! - Alt er fine!',
    WRONG: 'Unnskyld! Du hadde ikke nok riktige svar.',
    RETRY_GROUP: 'Forsøk på nytt',
    RETRY_TEST: 'Ta testen på nytt',
    HEADER_OUTCOME: 'Har du bestått testen?',
  },

  PROGRESSION: {
    EMPTY_MESSAGE: 'Progresjon på testar vil visast her',
    CONTENTS: {
      HEADER: 'Innhold',
    },
    TESTS: {
      HEADER: 'Tester',
      DESCRIPTION: `Du har utført: {done} av {total} tester`,
    },
  },

  PROGRESSION_INDICATOR: {
    FINISHED: 'Fullført',
    NOT_STARTED: 'Ikkje starta',
    NO_DATA: 'Ingen dato er angitt',
    OF: 'av',
  },

  ANSWERS_COUNTER: {
    CORRECT: 'Rett',
    WRONG: 'Feil',
  },

  MESSAGE_BANNER: {
    ERROR: 'Vi har litt tekniske problem, prøv att seinare?',
  },

  LEARNING_PATH: {
    CLOSE: 'Lukk',
    OVERVIEW: {
      SHOW: 'Vis oversikt',
      HIDE: 'Skjul oversikt',
    },
    PROGRESS: {
      STARTED: 'Startet',
      NOT_STARTED: 'Ikke startet',
      START: 'Start',
      FINISHED: 'Fullført',
      VIEW: 'Vis',
      CONTINUE: 'Fortsett',
    },
    LIST: {
      HEADER: 'Hald fram på nye læringsstiar',
    },
    NUMBER_OF_TASKS: '{ count } side | { count } sider',
    CONFIRMATION: {
      HEADER: 'Fullført!',
      SUBHEADER: 'Endringane er lagra',
      EXIT: 'Avslutt',
    },
    PROGRESSION: {
      TITLE: 'Oppsummering',
      ANSWER_ALL_QUESTIONS: 'Ikkje fullført',
      TRY_AGAIN: 'Fortset',
    },
    SUMMARY: {
      HEADER: 'Oppsummering',
      INFO: 'Du må svara på alle spørsmåla',
      COMPLETED: 'Fullført',
    },
    META: {
      SKILLS: 'Ferdigheter',
      PAGES: 'Sider',
    },
    SHOW_CONTENT: 'Vis innhald',
  },

  NAVIGATION_BUTTON: {
    PROCEED: 'Fortsett',
    NEXT: 'Neste',
    PREVIOUS: 'Førre',
  },

  CONTROLS: {
    CLOSE: 'Lukk',
    OPEN: 'Åpen',
    CANCEL: 'Avbryt',
    ACCEPT: 'Aksepterer',
  },

  TEACHER_DASHBOARD: {
    ADMIN: 'Admin',
    CLOSE: 'Lukk',
    HOME: 'Framside',
    STUDENT_DATA: 'Elevdata',
    VIEW_AS: 'Vis som',
    TEACHER: 'Lærer',
    STUDENT: 'Elev',
    LAST_VISIT: 'Siste',
    BUTTON_TEXT: 'Vis all data',
    TITLE: 'Elevdata',
    SEE_EXERCISES: 'Vis oppgaver',
    SORT: {
      LABEL: 'Sorter',
      ALL: 'Sistet aktivitet',
      NOT_STARTED: 'Ikkje startet',
      STARTED: 'Pågående',
      FINISHED: 'Fullført',
    },
  },

  TIMEGRAPH: {
    WEEK: 'Veke',
    MONTH: 'Måned',
    HALF_YEAR: '6 mnd',
    YEAR: '12 mnd',
    COMPLETED: 'Fullførte læringsstiar',
    DATA_PERIOD: 'Data for siste',
    MONTHS_NAMES: {
      JAN: 'Januar',
      FEB: 'Februar',
      MAR: 'Mars',
      APR: 'April',
      MAY: 'Mai',
      JUN: 'Juni',
      JUL: 'Juli',
      AUG: 'August',
      SEP: 'September',
      OCT: 'Oktober',
      NOV: 'November',
      DEC: 'Desember',
    },
    WEEKDAYS_NAMES: {
      MON: 'Måndag',
      TUE: 'Tysdag',
      WED: 'Onsdag',
      THU: 'Torsdag',
      FRI: 'Fredag',
      SAT: 'Laurdag',
      SUN: 'Søndag',
    },
    AMOUNT: 'Tal',
  },

  SKILL: {
    READ: 'Lese',
    WRITE: 'Skrive',
    LISTEN: 'Lytte',
    ORAL: 'Muntlig',
  },

  LAST_USED: {
    LEARNING_PATHS: {
      TITLE: 'Siste brukte læringsstiar',
      EMPTY_CONTENT: 'Her vil du sjå dine sist brukte læringsstiar',
    },
  },

  USER_INFO: {
    WELCOME: 'Velkommen',
    TIME_SPENT: 'Tid brukt',
    TIME_SPENT_VALUE: '{ hours } t { minutes } min',
    COMPLETED_CHAPTERS: 'Du har gjort',
    CHAPTERS: '{ completed } av { total } kapittel',
    WEEK: 'Veke',
  },
};
